import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute } from "@angular/router";
import { ApiService } from "src/app/services/api.service";
import { DialogService } from "src/app/services/dialog.service";
import { EmailService } from "src/app/services/email-service";
import { NavigationService } from "src/app/services/navigation.service";

@Component({
  selector: "app-save-mail",
  templateUrl: "./save-mail.component.html",
  styleUrls: ["./save-mail.component.scss"],
})
export class SaveMailComponent implements OnInit {
  templateName: string = "";
  templateDescription: string = "";
  brands: any;
  clientKey: any;
  moduleKey: any;
  selectedBrand: any;

  constructor(
    public emailService: EmailService,
    private dialogService: DialogService,
    private snackBar: MatSnackBar,
    private apiService: ApiService,
    private router: ActivatedRoute,
    private navigationService: NavigationService,
    public dialogRef: MatDialogRef<SaveMailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any // Inject the passed data
  ) {
    this.router.params.subscribe((p: any) => {
      this.router.queryParams.subscribe((params: any) => {
        let decryptedParams = this.navigationService.decryptData(params);
        this.clientKey = decryptedParams["cl_key"];
        this.moduleKey = decryptedParams["md_key"];
      });
    });
  }

  ngOnInit(): void {
    this.loadBrands();
  }

  loadBrands(): void {
    const obj = {
      client_key: this.clientKey,
      module_key: this.moduleKey,
    };

    this.apiService.post("kpi/get-brand-filter", obj).subscribe({
      next: (response: any) => {
        this.brands = response;
      },
      error: (error: any) => {
        console.error("Error fetching brands:", error);
      },
    });
  }

  popUpClose(): void {
    this.dialogRef.close();
  }

  saveTemplate(): void {
    // Create a FormData object
    const formData = new FormData();
    formData.append("template_name", this.templateName || "");
    formData.append("email_subject", this.data.subject || "");
    formData.append("email_body", this.data.body || "");
    formData.append("template_desc", this.templateDescription || "");
    formData.append("brand_key", this.selectedBrand || "");

    if (this.data.attachments && this.data.attachments.length > 0) {
      const filesArray = Array.from(this.data.attachments);
      filesArray.forEach((file: File | any) => {
        formData.append("Attachments", file); // Correct: file is a Blob
      });
    }

    // // Log FormData contents
    // console.log('FormData to Save:');
    // formData.forEach((value, key) => {
    //   if (value instanceof File) {
    //     console.log(`${key}: File - ${value.name}, ${value.size} bytes, ${value.type}`);
    //   } else {
    //     console.log(`${key}:`, value);
    //   }
    // });

    // Call the API to save the template
    this.emailService
      .createNewTemplates(formData)
      .then((response) => {
        // console.log("Template saved successfully:", response);

        // Show success snackbar
        this.snackBar.open("Template saved successfully!", "Close", {
          duration: 3000,
          panelClass: ["success-snackbar"],
        });

        this.dialogRef.close(response); // Close the dialog and pass the response back
      })
      .catch((error: any) => {
        console.error("Error saving template:", error);

        // Show error snackbar
        this.snackBar.open(
          "Failed to save template. Please try again.",
          "Close",
          {
            duration: 3000,
            panelClass: ["error-snackbar"],
          }
        );
      });
  }
}
